import { getField, updateField } from 'vuex-map-fields'
import getWorkflowTemplateFiltersModel from './models/workflowTemplateFilters'

const workflowTemplateFilters = {
  namespaced: true,
  state: {
    ...getWorkflowTemplateFiltersModel()
  },
  getters: {
    getField,
    getSearchObject (state) {
      const filters = {}
      if (state.businessEntityId) filters.businessEntityId = state.businessEntityId
      if (state.typeId) filters.typeId = state.typeId
      if (state.clientId) filters.clientId = state.clientId
      if (state.isActive !== null && state.isActive !== undefined) filters.isActive = state.isActive
      return filters
    }
  },
  mutations: {
    updateField,
    clearFilters (state) {
      const model = getWorkflowTemplateFiltersModel()
      Object.keys(model).forEach(key => { state[key] = model[key] })
    }
  }
}

export default workflowTemplateFilters
